import { Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import { FormikErrors, FormikTouched } from "formik";
import { InputError } from "src/grading/components/InputError";
import { Organization } from "src/store/reducers/organizations/organizationsApiSlice";
import useStyles from "./OrgGeneralInfo.styles";

interface OrgGeneralInfoProps {
  organization: Organization;
  onFieldChange: (field: string, value: string) => void;
  touched: FormikTouched<Organization>;
  errors: FormikErrors<Organization>;
}

const OrgGeneralInfo = ({
  organization,
  onFieldChange,
  touched,
  errors,
}: OrgGeneralInfoProps) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container} gap={3}>
      <Grid item xs={12}>
        <Typography variant="h4">General Information</Typography>
      </Grid>
      <Grid container className={classes.columnContainer}>
        <Grid container mb={1}>
          <Typography variant="h5" fontWeight="bold" color="black" mr={1}>
            Organization Name
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="#EB5757">
            *
          </Typography>
        </Grid>
        <Grid container mb={2}>
          <TextField
            fullWidth
            variant="outlined"
            value={organization.name}
            placeholder="Organization Name"
            onChange={(e) => onFieldChange("name", e.target.value)}
            error={InputError("name", touched, errors).error}
            helperText={InputError("name", touched, errors).helperText}
          />
        </Grid>
        <Grid container mb={1}>
          <Typography variant="h5" fontWeight="bold" color="black" mr={1}>
            Owner Name
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="#EB5757">
            *
          </Typography>
        </Grid>
        <Grid container mb={2}>
          <TextField
            fullWidth
            variant="outlined"
            value={organization.owner.name}
            placeholder="Owner"
            onChange={(e) => onFieldChange("owner.name", e.target.value)}
            error={InputError("owner.name", touched, errors).error}
            helperText={InputError("owner.name", touched, errors).helperText}
            disabled
          />
        </Grid>
      </Grid>
      <Grid container className={classes.columnContainer}>
        <Grid container mb={1}>
          <Typography variant="h5" fontWeight="bold" color="black" mr={1}>
            Branch
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="#EB5757">
            *
          </Typography>
        </Grid>
        <Grid container mb={2}>
          <Select
            fullWidth
            variant="outlined"
            value={organization.branch}
            onChange={(e) => {
              onFieldChange("branch", e.target.value);
            }}
            error={!!errors.branch}
          >
            <MenuItem value="army">Army</MenuItem>
            <MenuItem value="navy">Navy</MenuItem>
            <MenuItem value="airforce">Air Force</MenuItem>
            <MenuItem value="marine">Marine Corps</MenuItem>
            <MenuItem value="all">All</MenuItem>
          </Select>
        </Grid>
        <Grid container mb={1}>
          <Typography variant="h5" fontWeight="bold" color="black" mr={1}>
            Owner Email
          </Typography>
          <Typography variant="h5" fontWeight="bold" color="#EB5757">
            *
          </Typography>
        </Grid>
        <Grid container mb={2}>
          <TextField
            fullWidth
            variant="outlined"
            value={organization.owner.email}
            placeholder="Email"
            onChange={(e) => onFieldChange("owner.email", e.target.value)}
            error={InputError("owner.email", touched, errors).error}
            helperText={InputError("owner.email", touched, errors).helperText}
            disabled
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrgGeneralInfo;
